export const MODAL_PREFIX = 'modal-confirmation-';
export default { MODAL_PREFIX };
